import {
  PlayerStatChartConfigDto,
  BatterSingleSessionReportChartConfigDto,
  ChartType,
  PracticeBatterSingleSessionReportChartConfigDto,
  PracticeBatterSessionReportChartConfigDto,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig =
  | BatterSingleSessionReportChartConfigDto
  | PracticeBatterSessionReportChartConfigDto
  | PracticeBatterSingleSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<PlayerStatChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
};

const BattingStatChartSidebar = <T extends ReportConfig>({ chartConfig, setTempLayout, tempLayout, chartId, configKey }: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId as ChartType, chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={chartConfig.availableStats}
        selected={chartConfig.playerStat}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [configKey]: {
              ...tempLayout[configKey],
              playerStat: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default BattingStatChartSidebar;
